/**
 * Jeff, Oct 1 — the import grid's columns, shared by the grid (ImportPlayerGrid)
 * and its loading placeholder (ImportPreviousSeasonsSkeleton), so the two line up
 * and nothing moves when the players land: the tick, the player, the position,
 * the email. Kept free of AG Grid so the placeholder renders before that chunk.
 */
export const IMPORT_GRID_WIDTHS = {
  check: 44,
  playerFlex: 1.3,
  position: 124,
  emailFlex: 1.4,
} as const

/** The same columns as a CSS grid template, for the placeholder. */
export const IMPORT_GRID_COLUMNS = `${IMPORT_GRID_WIDTHS.check}px minmax(0, ${IMPORT_GRID_WIDTHS.playerFlex}fr) ${IMPORT_GRID_WIDTHS.position}px minmax(0, ${IMPORT_GRID_WIDTHS.emailFlex}fr)`

/** Header and row heights, and how many rows show before the body scrolls. */
export const IMPORT_GRID_HEADER_HEIGHT = 40
export const IMPORT_GRID_ROW_HEIGHT = 48
export const IMPORT_GRID_VISIBLE_ROWS = 7
